import { useState, useEffect } from 'react';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/pages/Home';
import Drony from './components/pages/Drony';
import Druk3D from './components/pages/Druk3D';
import Radio from './components/pages/Radio';
import ZHP from './components/pages/ZHP';
import Straz from './components/pages/Straz';

// --- EDIT THIS DATA TO CUSTOMIZE YOUR PAGE ---
const myPageData = {
  name: "Damian Krzywosz",
  contact: {
    email: "damian.krzwosz1@wp.pl",
    phone: "+48 887 857 531",
  },
  socials: {
    linkedin: "https://www.linkedin.com/in/damian-krzywosz-7a0ab62a0",
    github: "https://github.com/GitBread5",
    facebook: "https://www.facebook.com/damian.krzywosz.98",
    instagram: "https://www.instagram.com/damian_krzywosz"
  },
};
// ----------------------------------------------------

function AppContent() {
  const { t } = useLanguage();
  const [route, setRoute] = useState(window.location.hash || '#');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash || '#');
      window.scrollTo(0, 0);
    };
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('scroll', handleScroll);
    
    // Initial checks
    handleHashChange();
    handleScroll();

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { label: t('drones'), url: "#/drony" },
    { label: t('print3d'), url: "#/druk3d" },
    { label: t('radio'), url: "#/radio" },
    { label: t('zhp'), url: "#/zhp" },
    { label: t('guard'), url: "#/straz" },
  ];

  const renderContent = () => {
    switch (route) {
      case '#/drony':
        return <Drony />;
      case '#/druk3d':
        return <Druk3D />;
      case '#/radio':
        return <Radio />;
      case '#/zhp':
        return <ZHP />;
      case '#/straz':
        return <Straz />;
      default:
        return (
          <Home
            name={myPageData.name}
            title={t('title')}
            imageUrl="/ja.png"
            bio={t('bio')}
            skills={t('skills')}
          />
        );
    }
  };


  return (
    <div className="relative isolate flex flex-col min-h-screen bg-black text-gray-100 font-sans overflow-x-hidden">
      {/* Animated Aurora Background */}
      <div className="fixed inset-0 -z-10 h-full w-full bg-black">
        <div className="animate-aurora absolute -top-40 left-1/3 h-[400px] w-[400px] rounded-full bg-purple-500/80 opacity-20 blur-[120px]"></div>
        <div className="animate-aurora-2 absolute top-40 left-1/2 h-[400px] w-[400px] rounded-full bg-cyan-500/80 opacity-20 blur-[120px]"></div>
      </div>
      
      <Header 
        name={myPageData.name} 
        navLinks={navLinks} 
        isScrolled={isScrolled}
        currentRoute={route}
      />

      <main className="flex-grow container mx-auto px-6 sm:px-8 lg:px-12 pt-28 pb-20">
        {renderContent()}
      </main>

      <Footer name={myPageData.name} contact={myPageData.contact} socials={myPageData.socials} />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};

export default App;
